import { render, staticRenderFns } from "./PocList.vue?vue&type=template&id=553d90cd&scoped=true"
import script from "./PocList.vue?vue&type=script&lang=js"
export * from "./PocList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d90cd",
  null
  
)

export default component.exports